import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { stagger60ms } from '@vex/animations/stagger.animation';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { VexBreadcrumbsComponent } from '@vex/components/vex-breadcrumbs/vex-breadcrumbs.component';
import { VexSecondaryToolbarComponent } from '@vex/components/vex-secondary-toolbar/vex-secondary-toolbar.component';
import { Account, Channel, ChannelPayload, Connection } from 'src/app/interfaces';
import { AccountService } from 'src/app/services/account.service';
import { PlatformService } from 'src/app/services/platform.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'vl-platform',
  standalone: true,
  imports: [
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    NgIf,
    NgFor,
  ],
  templateUrl: './platform.component.html',
  styleUrl: './platform.component.scss'
})
export class PlatformComponent implements OnInit {

  public channels: ChannelPayload[] = [];
  private account: Account = <Account>{};
  private connectionId: string = "";
  private channelId: string = "";
  private accountId: string = "";
  private platform: string = "";
  private context: string = "";
  public code: string = "";


  constructor(private activatedRoute: ActivatedRoute, private accountService: AccountService, private platformService: PlatformService) {
    this.activatedRoute.params.subscribe((params) => {
      this.platform = <string>params['platform'];
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.code = params['code'];
      const state = JSON.parse(decodeURIComponent(params['state']));     
      this.accountId = state.accountId;
      this.channelId = state.chanelId,
      this.context = state.context;
    });
    this.channels = [
      {
        name: 'Be Beautiful Lily Smith',
        externalId: '100079247566642',
        avatarUrl: 'https://scontent-lhr6-2.xx.fbcdn.net/v/t39.30808-1/276093537_109860298327941_219226577739447004_n.jpg?stp=dst-jpg_p200x200&_nc_cat=104&ccb=1-7&_nc_sid=0ecb9b&_nc_ohc=6qTenizHZp8Q7kNvgF7nqfm&_nc_ht=scontent-lhr6-2.xx&oh=00_AYAjxPO33UPa2PE32Qm6I_SXcloWiDui5VFr6iKYFBIwOw&oe=668C712A',
        url: 'https://www.facebook.com/lily.smith.be.beautiful/',
        platform: 'facebook'
      },
    ];
  }

  ngOnInit(): void {
    this.accountService.getAccountById(this.accountId).subscribe((account: Account) => {
      this.account = account;
    });
    if (this.channelId) {
      this.platformService.refreshConnection(this.channelId, this.code).subscribe(() => {
        this.redirect(this.channelId)
      })
    } else {
      this.platformService.createConnection(this.platform, this.accountId, this.code).subscribe((connection: Connection) => {
        this.getChannels(connection._id)
        this.connectionId = connection._id
      })
    }
    
  }

  getChannels(connectionId: string) {
    this.platformService.getChannels(this.platform, connectionId).subscribe((channelPayloads: ChannelPayload[]) => {
      this.channels = [
        {
          name: 'Be Beautiful Lily Smith',
          externalId: '100079247566642',
          avatarUrl: 'https://scontent-lhr6-2.xx.fbcdn.net/v/t39.30808-1/276093537_109860298327941_219226577739447004_n.jpg?stp=dst-jpg_p200x200&_nc_cat=104&ccb=1-7&_nc_sid=0ecb9b&_nc_ohc=6qTenizHZp8Q7kNvgF7nqfm&_nc_ht=scontent-lhr6-2.xx&oh=00_AYAjxPO33UPa2PE32Qm6I_SXcloWiDui5VFr6iKYFBIwOw&oe=668C712A',
          url: 'https://www.facebook.com/lily.smith.be.beautiful/',
          platform: 'facebook'
        },
      ];
    });
  }

  selectChannel(matSelect: MatSelectChange) {
    const channelPayload = matSelect.value as ChannelPayload
    this.platformService.createChannel(this.platform, this.connectionId, channelPayload).subscribe((channel: Channel) => {
      this.redirect(channel._id);
    });
  }

  redirect(channelId: string) {
    const redirectURI = this.account.redirectURIs?.[0];
      const host = redirectURI ? redirectURI : 'https://subscrib.ly/channels';
      const uri = new URL(host);
      uri.searchParams.append("channelId", channelId);
      uri.searchParams.append("context", this.context);
      // location.replace(uri);
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.code);
  }


}
